function Ctrl($scope, $rootScope, utilsService, $uibModal, metaTagService) {
  $scope.showIos = true;

  metaTagService.set({
    title: 'Download Tablelist for iOS and Android',
    description: 'Download Tablelist for iOS and Android, the #1 app for access to VIP bottle service, private tables and exclusive events in a growing number of cities'
  });

  $scope.showDownloadLinks = function() {
    $uibModal.open({
      template: '<div id="download-links-modal" class="modal-body clearfix">' +
        '<div class="col-md-6">' +
        '<a class="apple" href="https://itunes.apple.com/app/tablelist/id634444177?mt=8" target="_blank" title="Download for iOS">' +
        '<img class="img-responsive" src="https://assets.tablelist.com/www-2/assets/download_apple.png">' +
        '</a>' +
        '</div>' +
        '<div class="col-md-6">' +
        '<a class="android" href="https://play.google.com/store/apps/details?id=com.tablelistapp.android.prod" target="_blank" title="Download for Android">' +
        '<img class="img-responsive" src="https://assets.tablelist.com/www-2/assets/download_android.png">' +
        '</a>' +
        '</div>' +
        '</div>',
      controller: [
        '$scope',
        '$uibModalInstance',
        ($scope2, $uibModalInstance) => {
          $scope2.close = function() {
            $uibModalInstance.dismiss('cancel');
          };
        }
      ]
    });
  };
}

Ctrl.$inject = [
  '$scope',
  '$rootScope',
  'utilsService',
  '$uibModal',
  'metaTagService'
];

export default Ctrl;



// WEBPACK FOOTER //
// ./src/components/download/downloadCtrl.js